







import { Component, Vue, Prop } from 'vue-property-decorator';

import { BlogCard } from '@/model/blog';

const initialItemData: BlogCard = {
  id: '',
  imageUrl: '',
  title: '',
  date: '',
  link: ''
};

@Component
export default class BlogItem extends Vue {
  @Prop({ required: true, default: () => ({ ...initialItemData }) })
  item!: BlogCard;
}
